export default __webpack_public_path__ + "static/default-profile-4b50fe5f41671d7269959096ccad6097.jpg";